import React,{useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Card, CardBody, Form, FormGroup, Input, Label, CustomInput, Button } from 'reactstrap';
import Cookies from 'universal-cookie'
import { toast } from 'react-toastify';
import { withRouter } from "react-router";
import { Link  } from 'react-router-dom';
import moment from 'moment';
import {findByMail, submitForgetPassword} from './../../../../actions/authAction';
import Divider from './../../../common/Divider';
import withRedirect from '../../../../hoc/withRedirect';

const ForgetPwdForm = (props) => {
    const { setRedirect, hasLabel, layout }=props;
    const [userName, setUserName]=useState();
    const [loading, setLoading]=useState(false);

    const onSubmitClick=async(e)=>{
        e.preventDefault();
        await setLoading(true);
        const result=await findByMail(userName);
        await setLoading(false);
        if(!result.error){
            const {data}=result;
            if(data===true){
                toast.error('This email id is not registered');
            }else{
                await setLoading(true);
                const resp=await submitForgetPassword({username:userName});
                await setLoading(false);
                if(resp.error){
                    toast.error(result.errorMessage);
                }else{
                    toast.success('Your password reset link has been sent to you registered email id');
                }
            }
        }else{
          toast.error(result.errorMessage);
        }
    }
    const onCancelClick=()=>{
        props.history.push('/login');
    }

    const renderForgetPwd=()=>{
        return <Form onSubmit={onSubmitClick}> 
        <FormGroup>
          <Label>Email</Label>
          <Input
            placeholder={'Email'}
            value={userName}
            onChange={e=>setUserName(e.target.value)}
            type="email" required
          />
        </FormGroup>
        <FormGroup>          
          <Button color="primary" block className="mt-3" 
          disabled={loading}
          >{
            loading?<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Loading</>:'Submit'
          }
            </Button>
        </FormGroup>
        <FormGroup>          
          <Button type='button' color="primary" block className="mt-3" onClick={onCancelClick}>Cancel</Button>
        </FormGroup>
      </Form>
      }


  return (<>{
    renderForgetPwd()
        }</>);
};

ForgetPwdForm.propTypes = {
  setRedirect: PropTypes.func.isRequired,
  layout: PropTypes.string,
  hasLabel: PropTypes.bool
};

ForgetPwdForm.defaultProps = {
  layout: 'basic',
  hasLabel: false
};

export default withRedirect(ForgetPwdForm);